import type { GlobalThemeOverrides } from "naive-ui";
import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme";

import resolveConfig from 'tailwindcss/resolveConfig';

const tailwindConfig: Config = {
  content: [],

  theme: {
    colors: {
      "primary": "#003F5C",
      "primary-hover": "#003F5C29",
      "secondary": "#59678029",
      "font-color-primary": "#003F5C",
      "font-color-secondary": "#596780",
      // "font-color-secondary-light": "#1479FF",
      "background-primary": "#FFFFFF",
      "background-secondary": "#59678029",
      // "background-secondary-dark": "#1479FF",
      "info": "#1479FF",
      "success": "#FFA600",
      "highlight": "#FF6E54",
      "alert": "#DD5182",
    },
  },
  fontFamily: {
    sans: ['Inter', 'Inter var', ...defaultTheme.fontFamily.sans],
    serif: ['Helvetica', 'serif'],
  }
};

const fullConfig: Config = resolveConfig(tailwindConfig)


type CustomColors = {
  "primary": string,
  "primary-hover": string,
  "secondary": string,
  "font-color-primary": string,
  "font-color-secondary": string,
  // "font-color-secondary-light": string,
  "background-primary": string,
  // "background-secondary": string,
  // "background-secondary-dark": string,
  "info": string,
  "success": string,
  "highlight": string,
  "alert": string,
}

const customColors: CustomColors = {
  ...(fullConfig.theme?.colors as unknown as CustomColors),
};

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: customColors.primary,
    primaryColorHover: customColors["primary-hover"],
    baseColor: "#FFF",
    hoverColor: customColors.primary + "29",
    textColorBase: customColors["font-color-primary"],
    bodyColor: "#F5F5F7", // Light gray background instead of pure white
    cardColor: "#FFFFFF", // White cards on gray background for contrast
    modalColor: "#FFFFFF",
    popoverColor: "#FFFFFF",
    tableColor: "#FFFFFF",
    infoColor: customColors.info,
    successColor: customColors.success,
    warningColor: customColors.highlight,
    errorColor: customColors.alert,
    borderColor: "#D1D5DB", // Darker border for better contrast
    dividerColor: "#E5E7EB",
  },
  Button: {
    textColor: customColors["font-color-primary"],
    textColorPrimary: "#FFFFFF",
    textColorHoverPrimary: "#FFF",
    textColorHover: "#FFF",
    colorHover: customColors.primary,
    colorHoverPrimary: customColors.primary,
  },
  Input: {
    color: "#FFFFFF",
    colorFocus: "#FFFFFF",
    textColor: customColors["font-color-primary"],
    placeholderColor: customColors["font-color-secondary"],
    caretColor: customColors.primary,
    border: "1px solid #E0E0E0",
    borderHover: "1px solid " + customColors.primary,
    borderFocus: "1px solid " + customColors.primary,
  },
  Form: {
    labelTextColor: customColors["font-color-primary"],
    labelFontWeight: "500",
  },
  Tabs: {
    paneTextColor: customColors["font-color-primary"],
    tabTextColorBar: customColors["font-color-secondary"],
    tabTextColorLine: customColors["font-color-secondary"],
  },
  Dialog: {
    textColor: customColors["font-color-secondary"],
    titleTextColor: customColors["font-color-primary"],
    titleFontWeight: "600",
    borderRadius: "16px",
    iconColor: customColors.primary,
    iconColorWarning: customColors.highlight,
    iconColorError: customColors.alert,
    iconColorInfo: customColors.primary,
    iconColorSuccess: customColors.success,
  },
  Card: {
    color: "#FFFFFF",
    borderColor: "#D1D5DB",
    borderRadius: "16px",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
  },
  Layout: {
    color: "#F5F5F7", // Match bodyColor for layout backgrounds
    siderColor: "#FFFFFF",
    headerColor: "#FFFFFF",
    footerColor: "#FFFFFF",
    siderBorderColor: "#D1D5DB",
    headerBorderColor: "#D1D5DB",
  }
};

export default themeOverrides;